import React from 'react'

import { Field } from 'formik'

import { Form, Col, Button } from '_zari/core'

import * as TiposCambioService from 'services/tiposCambio.service'

import { TipoCambioModal } from 'sharedComponents/modals'

// TODO > Consistencias constantes
const TipoCambioFormGroup = ({
  iFechaPagoValue,
  iMonedaPagoValue,
  vMoneda,
  iError,
  iTouched,
  fIsSubmitting,
  setFieldValue
}) => {
  const [mostrarTipoCambioModal, setMostrarTipoCambioModal] = React.useState(false)

  const consultarTipoCambio = React.useCallback(
    ({ moneda, tipoTasa }) => {
      TiposCambioService.getxFechaxMonedaxTipoCambio(iFechaPagoValue, moneda, tipoTasa).then(
        ({ data }) => {
          setFieldValue('tipoCambio', data.tipoCambio || 0)
        }
      )
    },
    [iFechaPagoValue, setFieldValue]
  )

  const handleCloseTipoCambioModal = React.useCallback(() => {
    setMostrarTipoCambioModal(false)
    consultarTipoCambio({ moneda: 'DOLARES', tipoTasa: 'VENT' })
  }, [consultarTipoCambio])

  React.useEffect(() => {
    if (iFechaPagoValue !== '' && vMoneda !== '') {
      consultarTipoCambio({ moneda: 'DOLARES', tipoTasa: 'VENT' })
    }
  }, [vMoneda, iFechaPagoValue, iMonedaPagoValue, setFieldValue, consultarTipoCambio])

  return (
    <>
      <Form.Group>
        <Form.Label text='T/C' htmlFor='input-tipoCambio' md={4} />
        <Col md={8}>
          <Form.InputGroup>
            <Field name='tipoCambio'>
              {({ field }) => (
                <Form.InputNumber
                  {...field}
                  disabled={fIsSubmitting}
                  isInvalid={iTouched && iError}
                  id='input-tipoCambio'
                />
              )}
            </Field>
            <Form.InputGroup.Prepend>
              <Button onClick={() => setMostrarTipoCambioModal(true)}>o</Button>
            </Form.InputGroup.Prepend>
          </Form.InputGroup>
          {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
        </Col>
      </Form.Group>
      <TipoCambioModal
        show={mostrarTipoCambioModal}
        handleClose={handleCloseTipoCambioModal}
        fechaReferencia={iFechaPagoValue}
      />
    </>
  )
}

export default React.memo(TipoCambioFormGroup)
